import { EDays } from "generated/graphql";
import React from "react";
import {
  DayContainer,
  DayOption,
} from "../MainStyles";

// SelectedDays is array of elements of  {"Mo", "Tu", "W", "Th", "F", "S"};
interface IDayItemReccurence {
  libelle: String;
  value: EDays;
}
interface IDayOptionReccurence {
  selectedDays: Array<EDays>;
  dayOptions: Array<IDayItemReccurence>;
  setSelectedDays: React.Dispatch<React.SetStateAction<Array<EDays>>>;
}

export default function DayOptionReccurence({
  selectedDays,
  dayOptions,
  setSelectedDays,
}: IDayOptionReccurence) {
  const [days, setDays] = React.useState(selectedDays || []);

  const handleClickDay = (day: EDays) => {
    const selectedIndex = days.findIndex((p) => p === day);
    let newSelected: EDays[];
    if (selectedIndex === -1) {
      newSelected = days.concat(day);
    } else if (selectedIndex >= 0) {
      newSelected = days.slice(0, selectedIndex).concat(days.slice(selectedIndex + 1));
    }
    setDays(newSelected);
    setSelectedDays(newSelected);
  };

  const renderDays = () => dayOptions?.map((day, index) => (
        <DayOption
          key={day.value}
          aria-selected={days?.indexOf(day?.value) !== -1}
          onClick={() => handleClickDay(day.value)}
        >
          {day?.libelle}
        </DayOption>
      ));

  return <DayContainer>{renderDays()}</DayContainer>;
}
